/* eslint-disable sonarjs/cognitive-complexity */
import React, { useEffect, useState, useRef } from 'react';
import IntlTelInput from 'react-intl-tel-input';
import { getSiteId } from '@tcp/core/src/utils';
import { isCanada } from '@tcp/core/src/utils/utils';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import Styles from '../CustomPhoneNumberInput.style';
import BodyCopy from '../../BodyCopy';

const ReduxFormIntlTelInput = ({
  input,
  className,
  meta,
  dispatchFormFieldChange,
  defaultPhoneNumber,
  defaultCountryCode,
  labelValue,
  addressBook,
  setPhoneCountryAction,
  containerRef,
}) => {
  useEffect(() => {
    const loadCSS = async () => {
      await import('react-intl-tel-input/dist/main.css');
    };
    loadCSS();
  }, []);
  const siteCountryCode = getSiteId()?.toLowerCase() || 'us';
  const [fieldTouched, setFieldTouched] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [defaultCountry, setDefaultCountry] = useState(siteCountryCode);
  const phoneInputRef = useRef(null);
  const { error, submitFailed } = meta;

  const handleChangeFunc = (value, countryData) => {
    const changedValue = value;
    const changeCountryData = countryData;
    const dialCode = `+${countryData.dialCode}`;
    setTimeout(() => {
      if (setPhoneCountryAction) {
        setPhoneCountryAction(dialCode);
      }
      dispatchFormFieldChange('phoneCountryCode', `+${changeCountryData.dialCode}`);
      input.onChange(changedValue);
    }, 0);
  };

  const handlePhoneNumberChange = (isValid, value, countryData) => {
    handleChangeFunc(value, countryData);
  };

  const handleFlagChange = (value, countryData) => {
    handleChangeFunc(value, countryData);
  };

  const getCountryCode = (dialCode) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const intlTelInput = phoneInputRef?.current;
        let countryData;
        if (intlTelInput) {
          countryData = intlTelInput.countries;
        }
        let result;
        const normalizedPhoneNumber = defaultPhoneNumber?.replace(/\D/g, '');
        // Check if the phone number starts with 787 or 939, set Puerto Rico if true
        if (
          (normalizedPhoneNumber?.startsWith('787') || normalizedPhoneNumber?.startsWith('939')) &&
          dialCode === '+1'
        ) {
          result = countryData?.find((country) => country.iso2 === 'pr');
        } else if (isCanada()) {
          result = countryData?.find((country) => country.dialCode === dialCode?.replace('+', ''));
        } else {
          result = countryData
            ?.slice()
            ?.reverse()
            ?.find((country) => country.dialCode === dialCode?.replace('+', ''));
        }
        resolve(result);
      }, 0);
    });
  };

  useEffect(() => {
    if (phoneInputRef.current) {
      getCountryCode(defaultCountryCode).then((countryCode) => {
        if (countryCode) {
          setDefaultCountry(countryCode?.iso2);
        }
      });
    }
  }, [defaultCountryCode]);

  const handleBlur = () => {
    setFieldTouched(true);
    setIsFocused(false);
  };

  useEffect(() => {
    const inputField = document.getElementById('phoneNumber');
    const handleKeyPress = (event) => {
      if (event.code === 'Enter' && containerRef && containerRef.current) {
        containerRef.current.click();
      }

      const { charCode } = event;
      if (!(charCode >= 48 && charCode <= 57)) {
        event.preventDefault();
      }
    };

    const handleFocus = () => {
      setIsFocused(true);
    };

    if (inputField) {
      inputField.addEventListener('keypress', handleKeyPress);
      inputField.addEventListener('focus', handleFocus);
    }

    return () => {
      if (inputField) {
        inputField.removeEventListener('keypress', handleKeyPress);
        inputField.removeEventListener('focus', handleFocus);
      }
    };
  }, []);

  const isErrored = (error && fieldTouched) || (submitFailed && error);
  const inputField = document.getElementById('phoneNumber');
  return (
    <div className={className}>
      <div className={`${isFocused || inputField?.value ? 'custom-phone-number-field' : ''}`}>
        {(isFocused || inputField?.value) && (
          <div className={`placeHolder ${isErrored ? 'placeholder-error' : 'placeholder-success'}`}>
            {labelValue}
          </div>
        )}
        <IntlTelInput
          key={defaultCountry}
          containerClassName="intl-tel-input"
          inputClassName={isErrored ? 'form-control-error' : 'form-control'}
          fieldId="phoneNumber"
          onPhoneNumberChange={handlePhoneNumberChange}
          onPhoneNumberBlur={handleBlur}
          onSelectFlag={handleFlagChange}
          preferredCountries={['us', 'ca']}
          defaultCountry={defaultCountry}
          defaultValue={defaultPhoneNumber || ''}
          separateDialCode={true}
          nationalMode={false}
          autoPlaceholder="polite"
          customPlaceholder={() => (isFocused ? '' : labelValue)}
          numberType="MOBILE"
          autoHideDialCode={false}
          ref={phoneInputRef}
          format={true}
          strictMode={true}
          useMobileFullscreenDropdown={false}
          fieldName={'phoneNumber'}
        />
        {isErrored && (
          <div className="error-component">
            {addressBook && <div className="warning-icon" aria-disabled="true" />}
            <BodyCopy
              color="error"
              component="div"
              fontSize="fs12"
              fontFamily="secondary"
              fontWeight={addressBook ? 'extrabold' : 'normal'}
              aria-live="assertive"
              data-locator="phone-number-error"
              id="error"
              className="elem-pb-XS"
            >
              {error}
            </BodyCopy>
          </div>
        )}
      </div>
    </div>
  );
};

export default withStyles(ReduxFormIntlTelInput, Styles);
export { ReduxFormIntlTelInput as ReduxFormIntlTelInputVanilla };
